/**
 * Module dependencies.
 */

import { BiSolidDownload } from 'react-icons/bi';
import { DownloadWrapper, StyledButton } from './product-description.style';
import { JSX, useMemo } from 'react';
import { Link } from 'components/atoms/link/link';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  product: any;
};

/**
 * Export `DownloadArea` component.
 */

export function DownloadArea({ product }: Props): JSX.Element {
  const { i18n, t: translate } = useTranslation();
  const lang = i18n.language;
  const { catalogProps, commercialCatalog, technicalCatalog } = useMemo(() => {
    const result: any = {};

    if (product?.catalog) {
      result.catalogProps = {
        href: `api/download?id=${product.catalog.filename_disk}&name=${product.catalog.filename_download}`,
      };
    }

    if (product?.technicalCatalog) {
      result.technicalCatalog = {
        href: `api/download?id=${product.technicalCatalog.filename_disk}&name=${product.technicalCatalog.filename_download}`,
      };
    }

    if (product?.commercialCatalog) {
      result.commercialCatalog = {
        href: `api/download?id=${product.commercialCatalog.filename_disk}&name=${product.commercialCatalog.filename_download}`,
      };
    }

    return result;
  }, [product.catalog, product.commercialCatalog, product.technicalCatalog]);

  return (
    <DownloadWrapper>
      {catalogProps && (
        <Link ghost {...catalogProps} target={'_blank'}>
          <StyledButton startIcon={<BiSolidDownload />}>
            {product.catalogName?.[lang] ?? translate('downloadArea.catalog')}
          </StyledButton>
        </Link>
      )}

      {technicalCatalog && (
        <Link ghost {...technicalCatalog} target={'_blank'}>
          <StyledButton startIcon={<BiSolidDownload />}>
            {product.technicalCatalogName?.[lang] ??
              translate('downloadArea.technicalCatalog')}
          </StyledButton>
        </Link>
      )}

      {commercialCatalog && (
        <Link ghost {...commercialCatalog} target={'_blank'}>
          <StyledButton startIcon={<BiSolidDownload />}>
            {product.commercialCatalogName?.[lang] ??
              translate('downloadArea.commercialCatalog')}
          </StyledButton>
        </Link>
      )}
    </DownloadWrapper>
  );
}
